import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";

import { RankCell } from "../../../React/Table/cells";

export const WebRanks = {
    id: "WebRanks",
    properties: {
        title: "metric.webRanks.title",
        family: "Website",
        component: "WebAnalysis",
        state: "digitalsuite_website_websiteperformance",
    },
    widgets: {
        single: {
            SingleMetric: {
                properties: {
                    width: "4",
                    headTemp: "web-rank-header",
                },
                objects: {
                    GlobalRank: {
                        name: "GlobalRank",
                        title: "wa.ao.ranks.global",
                        type: "long",
                        format: "swRankNumber",
                        cellTemp: "value-and-trend",
                        rowClass: "web-rank-row",
                    },
                    CountryRank: {
                        name: "CountryRank",
                        title: "wa.ao.ranks.country",
                        type: "long",
                        format: "swRankNumber",
                        cellTemp: "value-and-trend",
                        rowClass: "web-rank-row",
                    },
                    CategoryRank: {
                        name: "CategoryRank",
                        title: "wa.ao.ranks.category",
                        type: "long",
                        format: "swRankNumber",
                        cellTemp: "value-and-trend",
                        rowClass: "web-rank-row",
                    },
                },
            },
        },
        compare: {},
    },
};

export const WebRanksCategory = {
    id: "WebRanksCategory",
    properties: {
        group: "WebsiteAudienceOverview",
        title: "metric.webRanksCategory.title",
        family: "Website",
        component: "WebAnalysis",
        state: "digitalsuite_website_websiteperformance",
        titleState: "digitalsuite_marketresearch_webmarketanalysis_mapping",
    },
    widgets: {
        single: {},
        compare: {
            Table: {
                properties: {},
                columns: [
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "Rank",
                        title: "Rank",
                        type: "number",
                        format: "swRankNumber",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: RankCell,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        dangerouslySetInnerHTML: true,
                    },
                ],
                filters: {},
            },
        },
    },
};

export const WebRanksCategorySI = {
    ...WebRanksCategory,
    properties: {
        ...WebRanksCategory.properties,
        dashboard: "false",
        state: "accountreview_website_overview_websiteperformance",
    },
};

export const WebRanksCountry = {
    id: "WebRanksCountry",
    properties: {
        group: "WebsiteAudienceOverview",
        title: "metric.webRanksCountry.title",
        family: "Website",
        component: "WebAnalysis",
        state: "digitalsuite_website_websiteperformance",
        titleState: "digitalsuite_marketresearch_webmarketanalysis_mapping",
        apiController: "WebsiteOverview",
    },
    widgets: {
        single: {},
        compare: {
            Table: {
                properties: {},
                columns: [
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "Rank",
                        title: "Rank",
                        type: "number",
                        format: "swRankNumber",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: RankCell,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        dangerouslySetInnerHTML: true,
                    },
                ],
                filters: {},
            },
        },
    },
};

export const WebRanksCountrySI = {
    ...WebRanksCountry,
    properties: {
        ...WebRanksCountry.properties,
        dashboard: "false",
        state: "accountreview_website_overview_websiteperformance",
    },
};

export const WebRanksGlobal = {
    id: "WebRanksGlobal",
    properties: {
        group: "WebsiteAudienceOverview",
        title: "metric.webRanks.title",
        family: "Website",
        component: "WebAnalysis",
        state: "digitalsuite_website_websiteperformance",
        titleState: "digitalsuite_marketresearch_webmarketanalysis_mapping",
        apiController: "WebsiteOverview",
    },
    widgets: {
        single: {},
        compare: {
            Table: {
                properties: {},
                columns: [
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "Rank",
                        title: "Rank",
                        type: "number",
                        format: "swRank",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: RankCell,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        dangerouslySetInnerHTML: true,
                    },
                ],
                filters: {},
            },
        },
    },
};

export const WebRanksGlobalSI = {
    ...WebRanksGlobal,
    properties: {
        ...WebRanksGlobal.properties,
        dashboard: "false",
        state: "accountreview_website_overview_websiteperformance",
    },
};
